/**
 * Converts string to a number
 */
export function parseNumber (value: string) {
  if (value.includes('.')) {
    return parseFloat(value)
  } else {
    return parseInt(value)
  }
}

/**
 * Converts number into a ruby compatible stringified number (without e+/- format)
 */
export function stringifyNumber (value: number | string) {
  if (typeof value === 'string') return value

  const string = String(value)
  if (string.includes('e')) {
    const [, exp, sym, zeroesString] = string.match(/(\d[.\d]*)e(\+|\-)(\d+)/) as [string, string, string, string]

    const zeroes = parseInt(zeroesString)

    if (sym === '-') {
      return `0.${'0'.repeat(zeroes - 1)}${exp.replace('.', '')}`
    } else {
      return `${exp.replace('.', '')}${'0'.repeat(zeroes + 2 - exp.length)}`
    }
  } else {
    return string
  }
}